<div
    class="st-view-state-container"
    [class.isDiscover]="isDiscoverViewState$ | ngrxPush">
    <ng-content />
</div>
<mat-divider />
<div
    *ngIf="!(isDiscoverViewState$ | ngrxPush)"
    class="st-view-state-buttons-container">
    <button
        mat-button
        (click)="cancel()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-button
        color="primary"
        [disabled]="isSaveButtonDisabled$ | ngrxPush"
        (click)="save()">
        <ng-template
            [ngIf]="!loading"
            [ngIfElse]="loader">
            {{ (inEditMode$ | ngrxPush) ? languageSettings.PSTWebUpdateViewLabel : languageSettings.PSTWebCreateNewViewLabel }}
        </ng-template>
    </button>
</div>

<div
    *ngIf="(isDiscoverViewState$ | ngrxPush) && !(inAddContentSourceMode$ | ngrxPush)"
    class="st-view-state-buttons-container">
    <button
        mat-button
        mat-flat-button
        class="st-view-state-buttons-container-cancel-button"
        (click)="cancel()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <!-- <button
        *ngIf="!(inEditMode$ | ngrxPush)"
        mat-button
        mat-flat-button
        color="primary"
        [disabled]="isSaveButtonDisabled$ | ngrxPush"
        (click)="save()">
        {{ languageSettings.PSTWebCreateNewViewLabel }}
    </button> -->
    <button
        mat-button
        mat-flat-button
        color="primary"
        [disabled]="isSaveButtonDisabled$ | ngrxPush"
        (click)="save()">
        {{ (inEditMode$ | ngrxPush) ? languageSettings.PSTWebUpdateViewLabel : languageSettings.PSTWebCreateNewViewLabel }}
    </button>
</div>

<div
    *ngIf="(isDiscoverViewState$ | ngrxPush) && (inAddContentSourceMode$ | ngrxPush)"
    class="st-view-state-buttons-container">
    <button
        mat-button
        mat-flat-button
        class="st-view-state-buttons-container-cancel-button"
        (click)="back()">
        {{ languageSettings.PSTWebBackButtonLabel }}
    </button>
    <button
        mat-button
        mat-flat-button
        color="primary"
        [disabled]="isSaveButtonDisabled$ | ngrxPush"
        (click)="add()">
        {{ languageSettings.PSTWebAddToViewLabel }}
    </button>
</div>

<ng-template #loader>
    <st-loader
        class="st-view-state-create-footer-buttons--spinner"
        [diameter]="30"
        [strokeWidth]="5" />
</ng-template>
